const LOCALES = {
  nl: {
    days: ["Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
    months: [
      "Januari", "Februari", "Maart", "April", "Mei", "Juni",
      "Juli", "Augustus", "September", "Oktober", "November", "December"
    ],
    today: "Vandaag",
    tomorrow: "Morgen",
    openNow: "Nu Geopend",
    closedNow: "Nu Gesloten",
    closesAt: "Sluit om 17:00",
    opensTuesday: "Dinsdag open om 09:00",
    opensTomorrow: "Morgen open om 09:00",
    closedBadge: "Gesloten"
  },
  en: {
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    months: [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    today: "Today",
    tomorrow: "Tomorrow",
    openNow: "Open Now",
    closedNow: "Closed",
    closesAt: "Closes at 17:00",
    opensTuesday: "Opens Tuesday at 09:00",
    opensTomorrow: "Opens tomorrow at 09:00",
    closedBadge: "Closed"
  },
  tr: {
    days: ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"],
    months: [
      "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
      "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
    ],
    today: "Bugün",
    tomorrow: "Yarın",
    openNow: "Şu an Açık",
    closedNow: "Şu an Kapalı",
    closesAt: "Kapanış 17:00",
    opensTuesday: "Salı 09:00'da Açılıyor",
    opensTomorrow: "Yarın 09:00'da Açılıyor",
    closedBadge: "Kapalı"
  }
};

/**
 * Generate upcoming days based on current language
 * Marks Sunday (day 0) and Monday (day 1) as closed
 */
export function getUpcomingDays(count = 14, lang = 'nl') {
  const loc = LOCALES[lang] || LOCALES.nl;
  const days = [];
  const today = new Date();

  for (let i = 0; i < count; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);

    const dayOfWeek = d.getDay(); // 0 is Sunday, 1 is Monday
    const isClosedDay = dayOfWeek === 0 || dayOfWeek === 1; // Pazar & Pazartesi kapalı

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const iso = `${year}-${month}-${day}`;

    days.push({
      dateStr: iso,
      dayNumber: d.getDate(),
      dayName: i === 0 ? loc.today : i === 1 ? loc.tomorrow : loc.days[dayOfWeek],
      dayOfWeek,
      monthName: loc.months[d.getMonth()],
      isClosed: isClosedDay,
      rawDate: d
    });
  }

  return days;
}

/**
 * Generate standard available barber time slots
 * Strictly within Aura Hair's 09:00 - 17:00 hours
 */
export function getTimeSlots(lang = 'nl') {
  const periods = {
    nl: { morning: "Ochtend", afternoon: "Middag" },
    en: { morning: "Morning", afternoon: "Afternoon" },
    tr: { morning: "Sabah", afternoon: "Öğleden Sonra" }
  };
  const p = periods[lang] || periods.nl;

  return [
    { time: "09:00", period: p.morning },
    { time: "09:45", period: p.morning },
    { time: "10:30", period: p.morning },
    { time: "11:15", period: p.morning },
    { time: "12:00", period: p.afternoon },
    { time: "12:45", period: p.afternoon },
    { time: "13:30", period: p.afternoon },
    { time: "14:15", period: p.afternoon },
    { time: "15:00", period: p.afternoon },
    { time: "15:45", period: p.afternoon },
    { time: "16:15", period: p.afternoon }
  ];
}

/**
 * Format ISO date string (YYYY-MM-DD) to localized readable date
 */
export function formatLocalizedDate(isoString, lang = 'nl') {
  if (!isoString) return "";
  const parts = isoString.split("-");
  if (parts.length !== 3) return isoString;
  const d = new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
  const loc = LOCALES[lang] || LOCALES.nl;
  return `${loc.days[d.getDay()]} ${d.getDate()} ${loc.months[d.getMonth()]} ${d.getFullYear()}`;
}

/**
 * Check if the salon is currently open based on current time
 * Exact Aura Hair Schedule:
 * - Tuesday - Saturday: 09:00 - 17:00
 * - Sunday & Monday: CLOSED
 */
export function getSalonCurrentStatus(lang = 'nl') {
  const loc = LOCALES[lang] || LOCALES.nl;
  const now = new Date();
  const day = now.getDay(); // 0 = Sun, 1 = Mon, 2 = Tue, ..., 6 = Sat
  const hour = now.getHours();
  const minute = now.getMinutes();
  const currentTime = hour * 60 + minute;

  const openTime = 9 * 60; // 09:00
  const closeTime = 17 * 60; // 17:00

  // Sunday (0) and Monday (1) are closed
  const isWorkDay = day >= 2 && day <= 6;
  const isOpen = isWorkDay && currentTime >= openTime && currentTime < closeTime;

  let subText = "";
  if (isOpen) {
    subText = loc.closesAt;
  } else {
    if (day === 0 || day === 1) { // Sunday or Monday
      subText = loc.opensTuesday;
    } else if (day === 6 && currentTime >= closeTime) { // Saturday evening
      subText = loc.opensTuesday;
    } else {
      subText = loc.opensTomorrow;
    }
  }

  return {
    isOpen,
    statusText: isOpen ? loc.openNow : loc.closedNow,
    subText
  };
}
